<template>
  <v-app>
    <v-main
      :style="{
        'background-image': 'url(' + bg + ')',
        'background-repeat': 'round'
      }"
    >
      <transition name="component-fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>

    <div v-if="this.$route.name == 'home'">
      <v-footer dark padless style="background-color: #4c1a65">
        <!-- <v-btn color="#4c1a65" class="ma-2 white--text" @click="PrintPDF()"
          >พิมพ์ใบจอง</v-btn
        > -->
        <v-row
          no-gutters
          class="pa-2"
          padless
          style="background-color: #ffffff; color: red; font-size: 14px"
        >
          * ระบบเปิดให้จองชื่อสกุล ณ วันที่ 11 ธันวาคม พ.ศ.2567
          และการจองชื่อสกุลนี้มีผลตั้งแต่วันที่ 11 ธันวาคม พ.ศ.2567 เป็นต้นไป<br />
        </v-row>
        <!-- <v-row no-gutters class="pa-2" padless style="background-color: #ffffff; color: black; font-size: 14px">
          พระเกจิอาจารย์ ๙ รูป ๙ วัด ประกอบด้วย  <br />      
            ๑. พระราชวชิรสารสุธี (อเนก มนูณโญ) วัดนิเศธรรมประวัศิราชารวิทาร จังหวัดพระนครศรีอยุธยา<br />
            ๒. พระมงคลโมลี วิ. (หลวงปู่บุญ โสภโณ) วัดทุ่งเหียง จังหวัดชลบุรี<br />
            ๓. หลวงปู่สังวาลย์ ธมมสาโร วัดป่าเขามโนราห์ จังหวัดอุทัยธานี<br />
            ๔. พระอธิการประสงค์ (แดง) จันทวังโส วัดท่าแขก  จังหวัดเลย<br />
            ๕. พระครูถิรบุญญกร (หลวงพ่อสถิต ถิรปุญโญ) วัดพระเจตีย์แหลมสอ จังหวัดสุราษฎร์ธานี<br />
            ๖. พระครูวรวรรณวัฒน์ ดร. (นพบุรี มหาวณุโน) วัดพระธาตุดอยเวียงชัยมงคล จังหวัดเชียงใหม่<br />
            ๗. พระครูวิลาศกาญจนธรรม (พระอาจารย์เล็ก สุผมมปถโญ) วัดขนุน จังหวัดกาญจนบุรี<br />
            ๘. พระปลัดประกอบบุญ สิริญาโผ วัดมหาวันวนาราม พระอารามหลวง จังหวัดลำพูน<br />
            ๙. พระอาจารย์กฤษณ์ กิติญาโณ (พระอาจาย์ตุ๋ย) วัดนิมิตรโพริญาณ จังหวัดอุดรธานี<br /><br />
          * คำแนะนำ<br />ผู้จองชื่อสกุลจะต้องไปยื่นคำขอ (แบบ ช.1) เพื่อขอจดทะเบียนชื่อสกุลด้วยตนเอง
          ต่อนายทะเบียนท้องที่ที่ตนมีชื่ออยู่ในทะเบียนบ้าน ณ ที่ว่าการอำเภอ หรือสำนักงานเขต แล้วแต่กรณี
          โดยดำเนินการตามขั้นตอนการขอจดทะเบียนตั้งชื่อสกุลเช่นเดียวกับกรณีปกติ หากไม่ไปยื่นคำขอภายใน 90 วัน
          ให้ถือว่าผู้จองชื่อสกุลนี้ไม่ประสงค์ที่จะขอจดทะเบียนตั้งชื่อสกุลดังกล่าว
          หากมีปัญหาหรือข้อสงสัยโปรดติดต่อฝ่ายทะเบียนชื่อบุคคล ส่วนการทะเบียนทั่วไป หมายเลขโทรศัพท์ 0-2791-7048 - 7049
        </v-row> -->
        <v-row
          no-gutters
          class="pa-2"
          padless
          style="background-color: #ffffff; color: black; font-size: 14px"
        >
          พระเกจิอาจารย์ ๙ รูป ๙ วัด ประกอบด้วย <br />
          ๑. พระเทพสิงหวราจารย์ (โสภณ โสภโณ) วัดพระสิงห์วรมหาวิหาร
          จังหวัดเชียงใหม่<br />
          ๒. พระราชภาวนาวชิรมงคล วิ. (บุญเกียรติ กุลโสภโณ) วัดธรรมถาวร
          จังหวัดชุมพร<br />
          ๓. พระราชปริยัติ (ณษิกรณ์ อรินฺทโม) วัดศรีโคมคำ จังหวัดพะเยา<br />
          ๔. หลวงปู่ลี ตาณังกโร วัดหัวตลุกวนาราม จังหวัดนครสวรรค์<br />
          ๕. หลวงพ่อสายทอง เตชะธัมโม วัดป่าห้วยกุ่ม จังหวัดชัยภูมิ<br />
          ๖. พระครูพิพัฒน์อโนมคุณ (หลวงพ่อนัส อโนมปญฺโญ) วัดอ่างใหญ่
          จังหวัดตราด<br />
          ๗. พระครูวิศิษฎ์พิทยาคม (วราห์ ปุญญวโร) วัดโพธิทอง กรุงเทพมหานคร<br />
          ๘. พระมหาสุชาติ สิริปญฺโญ วัดวังก์วิเวการาม จังหวัดกาญจนบุรี<br />
          ๙. พระสมุห์ชัยศักดิ์ จนฺทสาโร วัดหน้าต่างนอก จังหวัดพระนครศรีอยุธยา<br /><br />
          * คำแนะนำ<br />ผู้จองชื่อสกุลจะต้องไปยื่นคำขอ (แบบ ช.1)
          เพื่อขอจดทะเบียนชื่อสกุลด้วยตนเอง
          ต่อนายทะเบียนท้องที่ที่ตนมีชื่ออยู่ในทะเบียนบ้าน ณ ที่ว่าการอำเภอ
          หรือสำนักงานเขต แล้วแต่กรณี
          โดยดำเนินการตามขั้นตอนการขอจดทะเบียนตั้งชื่อสกุลเช่นเดียวกับกรณีปกติ
          หากไม่ไปยื่นคำขอภายใน 90 วัน
          ให้ถือว่าผู้จองชื่อสกุลนี้ไม่ประสงค์ที่จะขอจดทะเบียนตั้งชื่อสกุลดังกล่าว
          หากมีปัญหาหรือข้อสงสัยโปรดติดต่อฝ่ายทะเบียนชื่อบุคคล
          ส่วนการทะเบียนทั่วไป หมายเลขโทรศัพท์ 0-2791-7048 - 7049
        </v-row>

        <v-row no-gutters>
          <v-card-text class="white--text pa-2" style="font-size: 12px">
            <span style="text-decoration: underline">ออกแบบและพัฒนาโดย</span>
            ส่วนบริหารและพัฒนาเทคโนโลยีการทะเบียน สำนักบริหารการทะเบียน
            กรมการปกครอง 59 หมู่ 11 ตำบลบึงทองหลาง อำเภอลำลูกกา จังหวัดปทุมธานี
            12150 โทร. 0-2791-7437,0-2791-7441,0-2791-7445 โทรสาร. 0-2906-9250
          </v-card-text>
        </v-row>
        <v-row no-gutters class="pa-2" style="font-size: 10px">
          version {{ require("../package.json").version }}
        </v-row>
      </v-footer>
    </div>
    <div v-else>
      <div class="text-right" style="font-size: 10px">
        version {{ require("../package.json").version }}
      </div>
    </div>

    <Loading ref="loading2" />
    <AlertBox ref="alertBox" />
  </v-app>
</template>

<script>
import bg from "./assets/bg.png";
import printReserve from "./pdf/printReserve.js";
import getFunctionPDF from "@/plugins/pdfmake-custom";
import printDoc from "@/plugins/print";
export default {
  name: "App",
  data() {
    return {
      bg,
      currentComponent: null,
      clerkName: null,
      OfficerName: null,
      workPlace: null,
      programName: null
    };
  },
  async mounted() {
    this.$store.state.loading2 = this.$refs.loading2;
    this.$store.state.alertBox = this.$refs.alertBox;

    // await require("./modules/api/apiDDOPA.js").default.test()

    this.$store.commit("resetState");
    if (this.$route.path == "/fromDDOPA") {
      this.$store.state.DDOPA.token = this.$route.query.token;
      this.$store.state.DDOPA.pid = this.$route.query.pid;
      this.$store.state.DDOPA.title = this.$route.query.title
      this.$store.state.DDOPA.fname = this.$route.query.fname;
      this.$store.state.DDOPA.lname = this.$route.query.lname;

      let response =
        await require("./modules/api/apiDDOPA.js").default.getCallback();
      this.$store.state.DDOPA.lnameWrite = response.lnameWrite;
      if (Number(response.menu) == 1) {
        this.$router.push("ReserveLname");
      } else if (Number(response.menu) == 2) {
        this.$router.push("EditReserv");
      } else if (Number(response.menu) == 3) {
        this.$router.push("Lnamedoc");
      } else {
        window.location.href = "./";
        return;
      }
    }
  },
  methods: {
    // PrintPDF: async function () {
    //   var widthScreen = window.innerWidth;
    //   let fullName = "ทดสอบ" + "/" + "ทดสอบ";
    //   let dataPrint = await printReserve.printReserveLname(
    //     1103100572731,
    //     fullName,
    //     "ทดสอบ",
    //     "21",
    //     25671111,
    //     "6711"
    //   );
    //   let option = { margin: [50, 50, 50, 50] };
    //   if (dataPrint != null) {
    //     if (widthScreen > 1024) {
    //       let pdf = await getFunctionPDF.pdfMake.createPdfToDataUrl(
    //         dataPrint,
    //         option
    //       );
    //       printDoc(pdf);
    //     } else {
    //       await getFunctionPDF.pdfMake
    //         .createPdf(dataPrint, option)
    //         .download("ใบจองชื่อสกุล.pdf");
    //     }
    //   }
    //   // console.log(this.$store.state.docNo)
    // }
  },
  updated() {
    if (this.$route.name === "CheckLname") {
      this.programName = "การตรวจสอบชื่อสกุลเบื้องต้นเพื่อจัดตั้ง";
    }
  },
  created() {
    if (window.location.hostname == "localhost") {
      document.cookie = "token=" + require("./config").default.useMockToken;
    }
    let newDate = new Date();
    let year = newDate.getFullYear();
    if (year < 2500) {
      year = year + 543;
    }
    let startYear = year;
    let j = 0;
    while (j < 100) {
      this.$store.state.listYearG.push({
        text: startYear,
        value: startYear
      });
      startYear--;
      j++;
    }
    for (let d = 1; d <= 31; d++) {
      let dDesc = "";
      if (d.toString().length === 1) {
        dDesc = "0" + d;
      } else {
        dDesc = d;
      }
      this.$store.state.listDayG.push({
        text: d,
        value: dDesc
      });
    }
  }
};
</script>

<style>
.bgapp {
  background-image: "./assets/bg.png";
  background-repeat: round;
}

* {
  font-family: "Prompt", sans-serif;
}

.theme--dark input[type="date"]::-webkit-calendar-picker-indicator {
  background-color: #ccc;
}

.v-label.theme--light {
  color: #4c1a65;
}

.strike {
  display: block;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
}

.strike > span {
  position: relative;
  display: inline-block;
}

.strike > span:before,
.strike > span:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 150px;
  height: 2px;
  background: #4c1a65;
}

.strike > span:before {
  right: 100%;
  margin-right: 15px;
}

.strike > span:after {
  left: 100%;
  margin-left: 15px;
}
</style>
